import { NgClass } from '@angular/common';
import { Component, effect, OnInit } from '@angular/core';
import { NavigationEnd, NavigationSkipped, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NavigationService } from '../navigation.service';
import { IconComponent } from '@shared/icon/icon.component';
import { UIService } from '@shared/ui.service';

@Component({
  selector: 'app-navigation-tab-bar',
  templateUrl: './navigation-tab-bar.component.html',
  styleUrl: './navigation-tab-bar.component.scss',
  imports: [IconComponent, RouterLink, RouterLinkActive, NgClass],
})
export class NavigationTabBarComponent implements OnInit {
  isOpenUIStateItem = false;
  isGameTab = false;
  isBrowseTab = false;

  constructor(public navigationService: NavigationService, public uiService: UIService, private router: Router) {
    effect(() => {
      this.isOpenUIStateItem = Object.values(uiService.uiStateMobile()).some((item) => item);
    });
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationSkipped) {
        this.uiService.closeUIStateMobile();
      }
      if (event instanceof NavigationEnd) {
        this.isGameTab = this.navigationService.games().some((game) => game.route === event.url);
        this.isBrowseTab = this.navigationService.MAINTENANCE.concat(this.navigationService.FEATURES).some((item) => item.route === event.url);

        this.uiService.closeUIStateMobile();
      }
    });
  }
}
